import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setClusterFeature } from "../../../../redux/action/ClusterFeature-action";
import { view } from "../../../../utils/API";
import { openClusterPopup } from "../../../../utils/clustering";
import { renderCell } from "../../../../utils/helper";
import { RightArrowIcon } from "../../../Icons";
import getClusterAttributeFields from "../../helpers/getClusterAttributeFields";
import { StyledNavButton } from "../../style/ClusterDetails/ClusterDetails-styled";

const ClusterDetails = ({ fields, feature, t, config, layer, children }) => {
  const cluster = layer.layerConfig.cluster;
  const { graphic, title, tabIndex, features } = useSelector(
    (state) => state.clusterFeature
  );
  const dispatch = useDispatch();
  const listener = useRef();

  useEffect(() => {
    if (!view) return;
    listener.current = reactiveUtils.when(
      () => !view.popup.visible,
      () => {
        dispatch(setClusterFeature(null));
      }
    );

    return () => {
      dispatch(setClusterFeature(null));
      listener.current?.remove();
    };
  }, []);

  const clusterFields = useMemo(
    () => getClusterAttributeFields(cluster, fields, t),
    [fields, t]
  );

  return (
    <div style={{ width: "100%" }}>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
        <StyledNavButton
          onClick={() => {
            listener.current?.remove();
            openClusterPopup({
              graphic,
              title,
              config,
              t,
              layer,
              tabIndex,
              clusterFeatures: features,
            });
          }}
        >
          <div
            style={{
              width: 16,
              height: 16,
              minWidth: 16,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <RightArrowIcon width="10" height="10" strokeWidth={1} />
          </div>
          <span style={{ fontSize: 10 }}>
            {clusterFields.fieldTitle1}
            {clusterFields.fieldTitle2 && ` / ${clusterFields.fieldTitle2}`}
          </span>
        </StyledNavButton>
      </div>
      <span style={{ fontSize: 10 }}>
        {renderCell(
          clusterFields.field2,
          feature.attributes[clusterFields.field2?.name],
          t,
          config
        )}
      </span>
      {children}
    </div>
  );
};

export default ClusterDetails;
